/* eslint-disable no-unused-vars */

import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CategoryList from "../category/CategoryList.jsx";
import ProductList from "../product/ProductList.jsx";
import PromotionList from "../promotion/PromotionList";
import ServiceList from "./ServiceList";
import API from "../../utils/API.js";
import db from "../../db/db.jsx";

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
export default function ProductHome(props) {
  const { t } = useTranslation();
  const translate = t;
  useEffect(() => {
    populateKOTPrinters();
    loadProductInfoFields();
    loadStoreAdminConfig();
  }, []);
  var biRef = {};
  const [value, setValue] = React.useState(0);

  const [kotPrinterOptions, setKotPrinterOptions] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [rUnitTypeOptions, setRUnitTypeOptions] = useState([]);
  const [productInfoFields, setProductInfoFields] = useState([]);
  const [storeAdminSetting, setStoreAdminSetting] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function loadProductInfoFields() {
    let dbData1 = await db.config.where("name").equals("UNIT_TYPES").toArray();
    setUnitTypeOptions(JSON.parse(dbData1[0].configTxt));

    let dbData2 = await db.config
      .where("name")
      .equals("RESTAURANT_UNIT_TYPES")
      .toArray();
    setRUnitTypeOptions(JSON.parse(dbData2[0].configTxt));

    let dbData = await db.config
      .where("name")
      .equals("PRODUCT_INFO_CUSTOM_FIELDS")
      .toArray();
    if (dbData && dbData.length == 1) {
      setProductInfoFields(JSON.parse(dbData[0].configTxt));
    }
  }

  async function loadStoreAdminConfig() {
    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();
    if (storeAdminVal && storeAdminVal[0] && storeAdminVal[0].sValue)
      setStoreAdminSetting(JSON.parse(storeAdminVal[0].sValue));
  }

  async function populateKOTPrinters() {
    if (props.context.appType === "R_POS") {
      const { data } = await API.get("/api/v1/allkotprinters");
      let p = [];
      p.push({ id: null, name: "None" });
      for (let d of data) {
        p.push({ id: d.id, name: d.name });
      }
      setKotPrinterOptions(p);
    }
  }

  return (
    <div>
      <Tabs value={value} onChange={handleChange}>
        {props.context.appType === "R_POS" && (
          <Tab label={translate("Restaurant Item")} />
        )}
        {props.context.appType === "M_POS" && (
          <Tab label={translate("Products")} />
        )}
        <Tab
          label={
            props.context.appType === "R_POS"
              ? translate("Inventory Item")
              : props.context.appType === "M_POS"
              ? translate("Raw Materials")
              : translate("Product")
          }
        />
        <Tab label={translate("Category")} />
        <Tab label={translate("Promotions")} />
        <Tab label={translate("Service")} />
      </Tabs>
      {props.context.appType == "R_POS" && (
        <TabPanel value={value} index={0}>
          <ProductList
            showMessage={props.showMessage}
            setAlert={props.setAlert}
            showProgress={props.showProgress}
            hideProgress={props.hideProgress}
            setProgressMessage={props.setProgressMessage}
            context={props.context}
            kotPrinterOptions={kotPrinterOptions}
            unitTypeOptions={rUnitTypeOptions}
            productInfoFields={productInfoFields}
            storeAdminSetting={storeAdminSetting}
            productType={"R"}
            productCache={props.productCache}
          />
        </TabPanel>
      )}
      {props.context.appType == "M_POS" && (
        <TabPanel value={value} index={0}>
          <ProductList
            showMessage={props.showMessage}
            setAlert={props.setAlert}
            showProgress={props.showProgress}
            hideProgress={props.hideProgress}
            setProgressMessage={props.setProgressMessage}
            context={props.context}
            kotPrinterOptions={kotPrinterOptions}
            unitTypeOptions={unitTypeOptions}
            productInfoFields={productInfoFields}
            storeAdminSetting={storeAdminSetting}
            productType={"P"}
            productCache={props.productCache}
          />
        </TabPanel>
      )}
      <TabPanel
        value={value}
        index={
          props.context.appType == "R_POS" || props.context.appType == "M_POS"
            ? 1
            : 0
        }
      >
        <ProductList
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
          context={props.context}
          kotPrinterOptions={kotPrinterOptions}
          unitTypeOptions={unitTypeOptions}
          productInfoFields={productInfoFields}
          storeAdminSetting={storeAdminSetting}
          productType={"I"}
          productCache={props.productCache}
        />
      </TabPanel>
      <TabPanel
        value={value}
        index={
          props.context.appType == "R_POS" || props.context.appType == "M_POS"
            ? 2
            : 1
        }
      >
        <CategoryList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
        />
      </TabPanel>
      <TabPanel
        value={value}
        index={
          props.context.appType == "R_POS" || props.context.appType == "M_POS"
            ? 3
            : 2
        }
      >
        <PromotionList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
        />
      </TabPanel>
      <TabPanel
        value={value}
        index={
          props.context.appType == "R_POS" || props.context.appType == "M_POS"
            ? 4
            : 3
        }
      >
        <ServiceList
          context={props.context}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
        />
      </TabPanel>
    </div>
  );
}
